import { GigType } from "model/Gig";
import type {
  ScheduleApiShiftItem,
  ScheduleApiWorkerRow,
} from "web-apps/company/components/schedule/types/schedule.types";

export interface DayTeam {
  readonly id: number;
  readonly name: string;
  readonly shifts: readonly DayShift[];
}

export interface DayShift {
  readonly endTime: string;
  readonly gigType?: GigType;
  readonly id: number;
  readonly isWorker: boolean;
  readonly role: string;
  readonly startTime: string;
  readonly workerExternalId: string;
  readonly workerName: string | null;
}

interface GroupScheduleDayShiftsParams {
  readonly rows: ScheduleApiWorkerRow[];
}

interface ToDayShiftParams {
  readonly item: ScheduleApiShiftItem;
  readonly row: ScheduleApiWorkerRow;
}

interface MutableDayTeam {
  id: number;
  name: string;
  shifts: DayShift[];
}

function toDayShift({ item, row }: ToDayShiftParams): DayShift {
  return {
    endTime: item.endTime,
    gigType: item.gigType,
    id: item.gigShiftId,
    isWorker:
      Boolean(item.workerExternalId) ||
      item.workerId != null ||
      row.isWorker !== false,
    role: row.text2?.trim() || row.text?.trim() || "",
    startTime: item.startTime,
    workerExternalId: item.workerExternalId ?? row.externalId,
    workerName:
      item.workerName?.trim() || (row.isWorker !== false ? row.heading : null),
  };
}

export function groupScheduleDayShifts({
  rows,
}: GroupScheduleDayShiftsParams): DayTeam[] {
  const groups = new Map<number, MutableDayTeam>();
  rows.forEach((row) => {
    row.items.forEach((item) => {
      const team = groups.get(item.workGroupId) ?? {
        id: item.workGroupId,
        name: item.workGroupName,
        shifts: [],
      };
      team.shifts.push(toDayShift({ item, row }));
      groups.set(item.workGroupId, team);
    });
  });
  return Array.from(groups.values());
}
